import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {toggleCollegeTestimonialHelpfulness} from 'shared/college-profile/actions/testimonials';
import Testimonial from 'shared/college-profile/components/about-college/about-testimonials/testimonial';

export const mapDispatchToProps = (dispatch) =>
  bindActionCreators({toggleCollegeTestimonialHelpfulness}, dispatch);

export default connect(null, mapDispatchToProps)(Testimonial);
